module.exports = __webpack_public_path__ + "media/images/aloe/icons/line/payment-bbe93cab25c561b32f8d117b81ac52f7.svg";